// Register all Stimulus controllers (bundled by esbuild).
import { application } from "./application"

import BulkActionsController from "./bulk_actions_controller";
application.register("bulk-actions", BulkActionsController);

import Checkbox_overlap_controller  from "./checkbox_overlap_controller";
application.register("checkbox-overlap", Checkbox_overlap_controller);

import Checkbox_row_controller from "./checkbox_row_controller";
application.register("checkbox-row", Checkbox_row_controller);

import Garage_tyre_barcode_scanner_controller from "./garage_tyre_barcode_scanner_controller";
application.register("garage-tyre-barcode-scanner", Garage_tyre_barcode_scanner_controller);

import RailsNestedForm from "./rails_nested_form_controller";
application.register("rails-nested-form", RailsNestedForm);

import Run_groups_controller from "./run_groups_controller";
application.register("run-groups", Run_groups_controller);

import Scrut_tyre_barcode_scanner_controller from "./scrut_tyre_barcode_scanner_controller";
application.register("scrut-tyre-barcode-scanner", Scrut_tyre_barcode_scanner_controller);

import Capitalise_input_controller from "./capitalise_input_controller";
application.register("capitalise-input", Capitalise_input_controller);

import Pill_filter_controller from "./pill_filter_controller";
application.register("pill-filter", Pill_filter_controller);

import Horizontal_scroll_controller from "./horizontal_scroll_controller";
application.register("horizontal-scroll", Horizontal_scroll_controller);
